// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"673":"date-range-picker","786":"graph"}[chunkId] || chunkId) + "." + {"19":"0c2ea89a","459":"66ff31c8","673":"0db989de","786":"03a9445a","790":"c638d3bb"}[chunkId] + ".chunk.js";
};